import { Flex } from "antd";
import React from "react";

interface PropsBulkPlanInfo {
  title: string;
  tasks?: string[];
}

export const BulkPlanInfo: React.FC<PropsBulkPlanInfo> = ({ title, tasks }) => (
  <Flex vertical gap={10}>
    <div>{title}:</div>
    <Flex vertical>
      {tasks?.map((task) => (
        <div key={task}>{task}</div>
      ))}
    </Flex>
  </Flex>
);
